import { Container } from "./styles";
import logo from "../../assets/logo-sem_fundo.png";
import { db } from "../../server";
import { IsLoged } from "../../App";
import { useNavigate } from "react-router";
import { useEffect, useRef, useState } from "react";

export default function Login() {
	const navigate = useNavigate();
	const passwordInputRef = useRef(null);

	const [username, setUsername] = useState();
	const [userPassword, setPassword] = useState();

	useEffect(() => {
		if (IsLoged() === "true") navigate("/");
	});

	async function doLogin({ user, password }) {
		if (!user || !password) return alert("Preencha todos os campos.");

		const snapshot = await db.collection("usuarios").get();

		let foundUser = null;
		let userId = null;

		snapshot.forEach((doc) => {
			const data = doc.data();
			if (data.user === user || data.mail === user) {
				foundUser = data;
				userId = doc.id;
			}
		});

		if (!foundUser) {
			return alert("Usuário não encontrado");
		}

		if (foundUser.password !== password) {
			return alert("Senha incorreta");
		}

		if (foundUser.firstAccess === true) {
			return navigate("/login/firstaccess/" + userId);
		}

		document.cookie = "isLoged=true; path=/;";
		document.cookie = `userId=${userId}; path=/;`;
		navigate("/");
	}
	return (
		<div>
			<Container>
				<div className="header">
					<img src={logo} alt="logo" />
					<h1>Entre na sua conta.</h1>
				</div>

				<div className="input-cover">
					<div className="input-wrapper">
						<label htmlFor="user">Usuário</label>
						<input
							type="text"
							name="user"
							id="user"
							placeholder="Nome de usuario ou e-mail"
							value={username}
							onChange={(e) => setUsername(e.target.value)}
							onKeyDown={(e) => {
								if (e.key === "Enter") {
									e.preventDefault();
									passwordInputRef.current?.focus();
								}
							}}
						/>
					</div>
					<div className="input-wrapper">
						<label htmlFor="password">Senha</label>
						<input
							type="password"
							name="password"
							id="password"
							ref={passwordInputRef}
							placeholder="Senha"
							value={userPassword}
							onChange={(e) => setPassword(e.target.value)}
							onKeyDown={(e) => {
								if (e.key === "Enter")
									doLogin({ user: username, password: userPassword });
							}}
						/>
					</div>
					<span>
						caso não saiba seu nome de usuário e senha entre em contato com um
						administrador!
					</span>
				</div>

				<button
					onClick={() => doLogin({ user: username, password: userPassword })}>
					Entrar
				</button>
			</Container>
		</div>
	);
}
